import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TokenIcon from '@/components/token/TokenIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BluesTokenIcon',
  props: {
    size: null,
    full: { type: Boolean },
    asLabel: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TokenIcon, {
    "icon-src": "/images/tokens/blues.svg",
    size: __props.size ?? '16',
    symbol: "BLUES",
    full: __props.full,
    "as-label": __props.asLabel
  }, null, 8, ["size", "full", "as-label"]))
}
}

})